/* Automatically generated file, do not update manually */
    import { Token } from 'types';

export const tokens: Token[] = [
  {
    symbol: 'CAKE',
    decimals: 18,
    chainId: 56,
    address: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82.png',
  },
  {
    symbol: '8PAY v2',
    decimals: 18,
    chainId: 56,
    address: '0x6EaDc05928ACd93eFB3FA0DFbC644D96C6Aa1Df8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6EaDc05928ACd93eFB3FA0DFbC644D96C6Aa1Df8.png',
  },
  {
    symbol: 'ACE',
    decimals: 18,
    chainId: 56,
    address: '0xc27A719105A987b4c34116223CAE8bd8F4B5def4',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xc27A719105A987b4c34116223CAE8bd8F4B5def4.png',
  },
  {
    symbol: 'ACH',
    decimals: 8,
    chainId: 56,
    address: '0xBc7d6B50616989655AfD682fb42743507003056D',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xBc7d6B50616989655AfD682fb42743507003056D.png',
  },
  {
    symbol: 'ADA',
    decimals: 18,
    chainId: 56,
    address: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47.png',
  },
  {
    symbol: 'ADX',
    decimals: 18,
    chainId: 56,
    address: '0x6bfF4Fb161347ad7de4A625AE5aa3A1CA7077819',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6bfF4Fb161347ad7de4A625AE5aa3A1CA7077819.png',
  },
  {
    symbol: 'AI',
    decimals: 18,
    chainId: 56,
    address: '0x2598c30330D5771AE9F983979209486aE26dE875',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2598c30330D5771AE9F983979209486aE26dE875.png',
  },
  {
    symbol: 'AIOZ',
    decimals: 18,
    chainId: 56,
    address: '0x33d08D8C7a168333a85285a68C0042b39fC3741D',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x33d08D8C7a168333a85285a68C0042b39fC3741D.png',
  },
  {
    symbol: 'AITECH',
    decimals: 18,
    chainId: 56,
    address: '0x2D060Ef4d6BF7f9e5edDe373Ab735513c0e4F944',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2D060Ef4d6BF7f9e5edDe373Ab735513c0e4F944.png',
  },
  {
    symbol: 'ALICE',
    decimals: 6,
    chainId: 56,
    address: '0xAC51066d7bEC65Dc4589368da368b212745d63E8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xAC51066d7bEC65Dc4589368da368b212745d63E8.png',
  },
  {
    symbol: 'ALPA',
    decimals: 18,
    chainId: 56,
    address: '0xc5E6689C9c8B02be7C49912Ef19e79cF24977f03',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xc5E6689C9c8B02be7C49912Ef19e79cF24977f03.png',
  },
  {
    symbol: 'ALPACA',
    decimals: 18,
    chainId: 56,
    address: '0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F.png',
  },
  {
    symbol: 'ALPHA',
    decimals: 18,
    chainId: 56,
    address: '0xa1faa113cbE53436Df28FF0aEe54275c13B40975',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa1faa113cbE53436Df28FF0aEe54275c13B40975.png',
  },
  {
    symbol: 'AMPL',
    decimals: 9,
    chainId: 56,
    address: '0xDB021b1B247fe2F1fa57e0A87C748Cc1E321F07F',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xDB021b1B247fe2F1fa57e0A87C748Cc1E321F07F.png',
  },
  {
    symbol: 'ANKR',
    decimals: 18,
    chainId: 56,
    address: '0xf307910A4c7bbc79691fD374889b36d8531B08e3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf307910A4c7bbc79691fD374889b36d8531B08e3.png',
  },
  {
    symbol: 'ankrBNB',
    decimals: 18,
    chainId: 56,
    address: '0x52F24a5e03aee338Da5fd9Df68D2b6FAe1178827',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x52F24a5e03aee338Da5fd9Df68D2b6FAe1178827.png',
  },
  {
    symbol: 'ankrETH',
    decimals: 18,
    chainId: 56,
    address: '0xe05A08226c49b636ACf99c40Da8DC6aF83CE5bB3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe05A08226c49b636ACf99c40Da8DC6aF83CE5bB3.png',
  },
  {
    symbol: 'ANTEX',
    decimals: 8,
    chainId: 56,
    address: '0xCA1aCAB14e85F30996aC83c64fF93Ded7586977C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xCA1aCAB14e85F30996aC83c64fF93Ded7586977C.png',
  },
  {
    symbol: 'anyMTLX',
    decimals: 18,
    chainId: 56,
    address: '0x5921DEE8556c4593EeFCFad3CA5e2f618606483b',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5921DEE8556c4593EeFCFad3CA5e2f618606483b.png',
  },
  {
    symbol: 'AOG',
    decimals: 18,
    chainId: 56,
    address: '0x40C8225329Bd3e28A043B029E0D07a5344d2C27C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x40C8225329Bd3e28A043B029E0D07a5344d2C27C.png',
  },
  {
    symbol: 'APE',
    decimals: 18,
    chainId: 56,
    address: '0xC762043E211571eB34f1ef377e5e8e76914962f9',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xC762043E211571eB34f1ef377e5e8e76914962f9.png',
  },
  {
    symbol: 'APX',
    decimals: 18,
    chainId: 56,
    address: '0x78F5d389F5CDCcFc41594aBaB4B0Ed02F31398b3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x78F5d389F5CDCcFc41594aBaB4B0Ed02F31398b3.png',
  },
  {
    symbol: 'APYS',
    decimals: 18,
    chainId: 56,
    address: '0x37dfACfaeDA801437Ff648A1559d73f4C40aAcb7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x37dfACfaeDA801437Ff648A1559d73f4C40aAcb7.png',
  },
  {
    symbol: 'ARENA',
    decimals: 18,
    chainId: 56,
    address: '0xCfFD4D3B517b77BE32C76DA768634dE6C738889B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xCfFD4D3B517b77BE32C76DA768634dE6C738889B.png',
  },
  {
    symbol: 'ARPA',
    decimals: 18,
    chainId: 56,
    address: '0x6F769E65c14Ebd1f68817F5f1DcDb61Cfa2D6f7e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6F769E65c14Ebd1f68817F5f1DcDb61Cfa2D6f7e.png',
  },
  {
    symbol: 'ARV',
    decimals: 8,
    chainId: 56,
    address: '0x6679eB24F59dFe111864AEc72B443d1Da666B360',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6679eB24F59dFe111864AEc72B443d1Da666B360.png',
  },
  {
    symbol: 'ASR',
    decimals: 2,
    chainId: 56,
    address: '0x80D5f92C2c8C682070C95495313dDB680B267320',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x80D5f92C2c8C682070C95495313dDB680B267320.png',
  },
  {
    symbol: 'ATA',
    decimals: 18,
    chainId: 56,
    address: '0xA2120b9e674d3fC3875f415A7DF52e382F141225',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xA2120b9e674d3fC3875f415A7DF52e382F141225.png',
  },
  {
    symbol: 'ATM',
    decimals: 2,
    chainId: 56,
    address: '0x25E9d05365c867E59C1904E7463Af9F312296f9E',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x25E9d05365c867E59C1904E7463Af9F312296f9E.png',
  },
  {
    symbol: 'ATOM',
    decimals: 18,
    chainId: 56,
    address: '0x0Eb3a705fc54725037CC9e008bDede697f62F335',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0Eb3a705fc54725037CC9e008bDede697f62F335.png',
  },
  {
    symbol: 'AUTO',
    decimals: 18,
    chainId: 56,
    address: '0xa184088a740c695E156F91f5cC086a06bb78b827',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa184088a740c695E156F91f5cC086a06bb78b827.png',
  },
  {
    symbol: 'AXL',
    decimals: 6,
    chainId: 56,
    address: '0x8b1f4432F943c465A973FeDC6d7aa50Fc96f1f65',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8b1f4432F943c465A973FeDC6d7aa50Fc96f1f65.png',
  },
  {
    symbol: 'axlSTARS',
    decimals: 6,
    chainId: 56,
    address: '0xC3CAC4AE38cCf6985EF9039ACC1abBc874DdcBB0',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xC3CAC4AE38cCf6985EF9039ACC1abBc874DdcBB0.png',
  },
  {
    symbol: 'axlUSDC',
    decimals: 6,
    chainId: 56,
    address: '0x4268B8F0B87b6Eae5d897996E6b845ddbD99Adf3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4268B8F0B87b6Eae5d897996E6b845ddbD99Adf3.png',
  },
  {
    symbol: 'AXS',
    decimals: 18,
    chainId: 56,
    address: '0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0.png',
  },
  {
    symbol: 'BABYCAKE',
    decimals: 18,
    chainId: 56,
    address: '0xdB8D30b74bf098aF214e862C90E647bbB1fcC58c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xdB8D30b74bf098aF214e862C90E647bbB1fcC58c.png',
  },
  {
    symbol: 'BAKE',
    decimals: 18,
    chainId: 56,
    address: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5.png',
  },
  {
    symbol: 'bALBT',
    decimals: 18,
    chainId: 56,
    address: '0x72fAa679E1008Ad8382959FF48E392042A8b06f7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x72fAa679E1008Ad8382959FF48E392042A8b06f7.png',
  },
  {
    symbol: 'BAND',
    decimals: 18,
    chainId: 56,
    address: '0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18.png',
  },
  {
    symbol: 'BAT',
    decimals: 18,
    chainId: 56,
    address: '0x101d82428437127bF1608F699CD651e6Abf9766E',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x101d82428437127bF1608F699CD651e6Abf9766E.png',
  },
  {
    symbol: 'BATH',
    decimals: 18,
    chainId: 56,
    address: '0x0bc89aa98Ad94E6798Ec822d0814d934cCD0c0cE',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0bc89aa98Ad94E6798Ec822d0814d934cCD0c0cE.png',
  },
  {
    symbol: 'bBADGER',
    decimals: 18,
    chainId: 56,
    address: '0x1F7216fdB338247512Ec99715587bb97BBf96eae',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1F7216fdB338247512Ec99715587bb97BBf96eae.png',
  },
  {
    symbol: 'BBT',
    decimals: 8,
    chainId: 56,
    address: '0xD48474E7444727bF500a32D5AbE01943f3A59A64',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xD48474E7444727bF500a32D5AbE01943f3A59A64.png',
  },
  {
    symbol: 'bCFX',
    decimals: 18,
    chainId: 56,
    address: '0x045c4324039dA91c52C55DF5D785385Aab073DcF',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x045c4324039dA91c52C55DF5D785385Aab073DcF.png',
  },
  {
    symbol: 'BCH',
    decimals: 18,
    chainId: 56,
    address: '0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf.png',
  },
  {
    symbol: 'BCOIN',
    decimals: 18,
    chainId: 56,
    address: '0x00e1656e45f18ec6747F5a8496Fd39B50b38396D',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x00e1656e45f18ec6747F5a8496Fd39B50b38396D.png',
  },
  {
    symbol: 'bDIGG',
    decimals: 18,
    chainId: 56,
    address: '0x5986D5c77c65e5801a5cAa4fAE80089f870A71dA',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5986D5c77c65e5801a5cAa4fAE80089f870A71dA.png',
  },
  {
    symbol: 'BDO',
    decimals: 18,
    chainId: 56,
    address: '0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454.png',
  },
  {
    symbol: 'BEL',
    decimals: 18,
    chainId: 56,
    address: '0x8443f091997f06a61670B735ED92734F5628692F',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8443f091997f06a61670B735ED92734F5628692F.png',
  },
  {
    symbol: 'BELT',
    decimals: 18,
    chainId: 56,
    address: '0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f.png',
  },
  {
    symbol: 'BETA',
    decimals: 18,
    chainId: 56,
    address: '0xBe1a001FE942f96Eea22bA08783140B9Dcc09D28',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xBe1a001FE942f96Eea22bA08783140B9Dcc09D28.png',
  },
  {
    symbol: 'BETH',
    decimals: 18,
    chainId: 56,
    address: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B.png',
  },
  {
    symbol: 'BFI',
    decimals: 18,
    chainId: 56,
    address: '0x81859801b01764D4f0Fa5E64729f5a6C3b91435b',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x81859801b01764D4f0Fa5E64729f5a6C3b91435b.png',
  },
  {
    symbol: 'BIFI',
    decimals: 18,
    chainId: 56,
    address: '0xCa3F508B8e4Dd382eE878A314789373D80A5190A',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xCa3F508B8e4Dd382eE878A314789373D80A5190A.png',
  },
  {
    symbol: 'BITU',
    decimals: 18,
    chainId: 56,
    address: '0x654A32542A84bEA7D2c2C1A1Ed1AAAf26888E6bD',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x654A32542A84bEA7D2c2C1A1Ed1AAAf26888E6bD.png',
  },
  {
    symbol: 'BLK',
    decimals: 6,
    chainId: 56,
    address: '0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F.png',
  },
  {
    symbol: 'BMON',
    decimals: 18,
    chainId: 56,
    address: '0x08ba0619b1e7A582E0BCe5BBE9843322C954C340',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x08ba0619b1e7A582E0BCe5BBE9843322C954C340.png',
  },
  {
    symbol: 'bMXX',
    decimals: 18,
    chainId: 56,
    address: '0x4131b87F74415190425ccD873048C708F8005823',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4131b87F74415190425ccD873048C708F8005823.png',
  },
  {
    symbol: 'BNBx',
    decimals: 18,
    chainId: 56,
    address: '0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275.png',
  },
  {
    symbol: 'BNX',
    decimals: 18,
    chainId: 56,
    address: '0x5b1f874d0b0C5ee17a495CbB70AB8bf64107A3BD',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5b1f874d0b0C5ee17a495CbB70AB8bf64107A3BD.png',
  },
  {
    symbol: 'BONDLY',
    decimals: 18,
    chainId: 56,
    address: '0x5D0158A5c3ddF47d4Ea4517d8DB0D76aA2e87563',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5D0158A5c3ddF47d4Ea4517d8DB0D76aA2e87563.png',
  },
  {
    symbol: 'Bonk',
    decimals: 5,
    chainId: 56,
    address: '0xA697e272a73744b343528C3Bc4702F2565b2F422',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xA697e272a73744b343528C3Bc4702F2565b2F422.png',
  },
  {
    symbol: 'BORING',
    decimals: 18,
    chainId: 56,
    address: '0xffEecbf8D7267757c2dc3d13D730E97E15BfdF7F',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xffEecbf8D7267757c2dc3d13D730E97E15BfdF7F.png',
  },
  {
    symbol: 'BOXY',
    decimals: 18,
    chainId: 56,
    address: '0x9F5d4479b783327b61718fa13B3a0583869a80c1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9F5d4479b783327b61718fa13B3a0583869a80c1.png',
  },
  {
    symbol: 'BP',
    decimals: 18,
    chainId: 56,
    address: '0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1.png',
  },
  {
    symbol: 'bROOBEE',
    decimals: 18,
    chainId: 56,
    address: '0xE64F5Cb844946C1F102Bd25bBD87a5aB4aE89Fbe',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xE64F5Cb844946C1F102Bd25bBD87a5aB4aE89Fbe.png',
  },
  {
    symbol: 'BRY',
    decimals: 18,
    chainId: 56,
    address: '0xf859Bf77cBe8699013d6Dbc7C2b926Aaf307F830',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf859Bf77cBe8699013d6Dbc7C2b926Aaf307F830.png',
  },
  {
    symbol: 'BSCDEFI',
    decimals: 18,
    chainId: 56,
    address: '0x40E46dE174dfB776BB89E04dF1C47d8a66855EB3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x40E46dE174dfB776BB89E04dF1C47d8a66855EB3.png',
  },
  {
    symbol: 'BSCPAD',
    decimals: 18,
    chainId: 56,
    address: '0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700.png',
  },
  {
    symbol: 'BSCX',
    decimals: 18,
    chainId: 56,
    address: '0x5Ac52EE5b2a633895292Ff6d8A89bB9190451587',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5Ac52EE5b2a633895292Ff6d8A89bB9190451587.png',
  },
  {
    symbol: 'BSW',
    decimals: 18,
    chainId: 56,
    address: '0x965F527D9159dCe6288a2219DB51fc6Eef120dD1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x965F527D9159dCe6288a2219DB51fc6Eef120dD1.png',
  },
  {
    symbol: 'BTCB',
    decimals: 18,
    chainId: 56,
    address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c.png',
  },
  {
    symbol: 'BTCST',
    decimals: 17,
    chainId: 56,
    address: '0x78650B139471520656b9E7aA7A5e9276814a38e9',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x78650B139471520656b9E7aA7A5e9276814a38e9.png',
  },
  {
    symbol: 'BTR',
    decimals: 18,
    chainId: 56,
    address: '0x5a16E8cE8cA316407c6E6307095dc9540a8D62B3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5a16E8cE8cA316407c6E6307095dc9540a8D62B3.png',
  },
  {
    symbol: 'BTT',
    decimals: 18,
    chainId: 56,
    address: '0x352Cb5E19b12FC216548a2677bD0fce83BaE434B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x352Cb5E19b12FC216548a2677bD0fce83BaE434B.png',
  },
  {
    symbol: 'BTTOLD',
    decimals: 18,
    chainId: 56,
    address: '0x8595F9dA7b868b1822194fAEd312235E43007b49',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8595F9dA7b868b1822194fAEd312235E43007b49.png',
  },
  {
    symbol: 'BUNNY',
    decimals: 18,
    chainId: 56,
    address: '0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51.png',
  },
  {
    symbol: 'BURGER',
    decimals: 18,
    chainId: 56,
    address: '0xAe9269f27437f0fcBC232d39Ec814844a51d6b8f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xAe9269f27437f0fcBC232d39Ec814844a51d6b8f.png',
  },
  {
    symbol: 'BUSD',
    decimals: 18,
    chainId: 56,
    address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56.png',
  },
  {
    symbol: 'BUX',
    decimals: 18,
    chainId: 56,
    address: '0x211FfbE424b90e25a15531ca322adF1559779E45',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x211FfbE424b90e25a15531ca322adF1559779E45.png',
  },
  {
    symbol: 'C98',
    decimals: 18,
    chainId: 56,
    address: '0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6.png',
  },
  {
    symbol: 'CAPS',
    decimals: 18,
    chainId: 56,
    address: '0xFfBa7529AC181c2Ee1844548e6D7061c9A597dF4',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xFfBa7529AC181c2Ee1844548e6D7061c9A597dF4.png',
  },
  {
    symbol: 'CART',
    decimals: 18,
    chainId: 56,
    address: '0x5C8C8D560048F34E5f7f8ad71f2f81a89DBd273e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5C8C8D560048F34E5f7f8ad71f2f81a89DBd273e.png',
  },
  {
    symbol: 'CAT',
    decimals: 18,
    chainId: 56,
    address: '0x6894CDe390a3f51155ea41Ed24a33A4827d3063D',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6894CDe390a3f51155ea41Ed24a33A4827d3063D.png',
  },
  {
    symbol: 'CEEK',
    decimals: 18,
    chainId: 56,
    address: '0xe0F94Ac5462997D2BC57287Ac3a3aE4C31345D66',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe0F94Ac5462997D2BC57287Ac3a3aE4C31345D66.png',
  },
  {
    symbol: 'CGG',
    decimals: 18,
    chainId: 56,
    address: '0x1613957159E9B0ac6c80e824F7Eea748a32a0AE2',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1613957159E9B0ac6c80e824F7Eea748a32a0AE2.png',
  },
  {
    symbol: 'CGPT',
    decimals: 18,
    chainId: 56,
    address: '0x9840652DC04fb9db2C43853633f0F62BE6f00f98',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9840652DC04fb9db2C43853633f0F62BE6f00f98.png',
  },
  {
    symbol: 'CHAMP',
    decimals: 18,
    chainId: 56,
    address: '0x7e9AB560d37E62883E882474b096643caB234B65',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7e9AB560d37E62883E882474b096643caB234B65.png',
  },
  {
    symbol: 'CHESS',
    decimals: 18,
    chainId: 56,
    address: '0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6.png',
  },
  {
    symbol: 'CHR',
    decimals: 6,
    chainId: 56,
    address: '0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE.png',
  },
  {
    symbol: 'CKP',
    decimals: 18,
    chainId: 56,
    address: '0x2B5D9ADea07B590b638FFc165792b2C610EdA649',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2B5D9ADea07B590b638FFc165792b2C610EdA649.png',
  },
  {
    symbol: 'CO',
    decimals: 6,
    chainId: 56,
    address: '0x936B6659Ad0C1b244Ba8Efe639092acae30dc8d6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x936B6659Ad0C1b244Ba8Efe639092acae30dc8d6.png',
  },
  {
    symbol: 'COMP',
    decimals: 18,
    chainId: 56,
    address: '0x52CE071Bd9b1C4B00A0b92D298c512478CaD67e8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x52CE071Bd9b1C4B00A0b92D298c512478CaD67e8.png',
  },
  {
    symbol: 'COS',
    decimals: 18,
    chainId: 56,
    address: '0x96Dd399F9c3AFda1F194182F71600F1B65946501',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x96Dd399F9c3AFda1F194182F71600F1B65946501.png',
  },
  {
    symbol: 'CREAM',
    decimals: 18,
    chainId: 56,
    address: '0xd4CB328A82bDf5f03eB737f37Fa6B370aef3e888',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xd4CB328A82bDf5f03eB737f37Fa6B370aef3e888.png',
  },
  {
    symbol: 'CSIX',
    decimals: 18,
    chainId: 56,
    address: '0x04756126F044634C9a0f0E985e60c88a51ACC206',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x04756126F044634C9a0f0E985e60c88a51ACC206.png',
  },
  {
    symbol: 'CTK',
    decimals: 6,
    chainId: 56,
    address: '0xA8c2B8eec3d368C0253ad3dae65a5F2BBB89c929',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xA8c2B8eec3d368C0253ad3dae65a5F2BBB89c929.png',
  },
  {
    symbol: 'CVP',
    decimals: 18,
    chainId: 56,
    address: '0x5Ec3AdBDae549Dce842e24480Eb2434769e22B2E',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5Ec3AdBDae549Dce842e24480Eb2434769e22B2E.png',
  },
  {
    symbol: 'CYBER',
    decimals: 18,
    chainId: 56,
    address: '0x14778860E937f509e651192a90589dE711Fb88a9',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x14778860E937f509e651192a90589dE711Fb88a9.png',
  },
  {
    symbol: 'CYC',
    decimals: 18,
    chainId: 56,
    address: '0x810EE35443639348aDbbC467b33310d2AB43c168',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x810EE35443639348aDbbC467b33310d2AB43c168.png',
  },
  {
    symbol: 'DAI',
    decimals: 18,
    chainId: 56,
    address: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3.png',
  },
  {
    symbol: 'DAO',
    decimals: 18,
    chainId: 56,
    address: '0x4d2d32d8652058Bf98c772953E1Df5c5c85D9F45',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4d2d32d8652058Bf98c772953E1Df5c5c85D9F45.png',
  },
  {
    symbol: 'DAR',
    decimals: 6,
    chainId: 56,
    address: '0x23CE9e926048273eF83be0A3A8Ba9Cb6D45cd978',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x23CE9e926048273eF83be0A3A8Ba9Cb6D45cd978.png',
  },
  {
    symbol: 'DCK',
    decimals: 18,
    chainId: 56,
    address: '0x16faF9DAa401AA42506AF503Aa3d80B871c467A3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x16faF9DAa401AA42506AF503Aa3d80B871c467A3.png',
  },
  {
    symbol: 'DECHAT',
    decimals: 18,
    chainId: 56,
    address: '0xD69ee2e508363FEd57f89917D5ca03e715ee5519',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xD69ee2e508363FEd57f89917D5ca03e715ee5519.png',
  },
  {
    symbol: 'DEFI',
    decimals: 18,
    chainId: 56,
    address: '0x6d106C0B8d2f47c5465bdBD58D1Be253762cBBC1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6d106C0B8d2f47c5465bdBD58D1Be253762cBBC1.png',
  },
  {
    symbol: 'DEGO',
    decimals: 18,
    chainId: 56,
    address: '0x3FdA9383A84C05eC8f7630Fe10AdF1fAC13241CC',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3FdA9383A84C05eC8f7630Fe10AdF1fAC13241CC.png',
  },
  {
    symbol: 'DERI',
    decimals: 18,
    chainId: 56,
    address: '0xe60eaf5A997DFAe83739e035b005A33AfdCc6df5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe60eaf5A997DFAe83739e035b005A33AfdCc6df5.png',
  },
  {
    symbol: 'DEXE',
    decimals: 18,
    chainId: 56,
    address: '0x039cB485212f996A9DBb85A9a75d898F94d38dA6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x039cB485212f996A9DBb85A9a75d898F94d38dA6.png',
  },
  {
    symbol: 'DEXE',
    decimals: 18,
    chainId: 56,
    address: '0x6E88056E8376Ae7709496Ba64d37fa2f8015ce3e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6E88056E8376Ae7709496Ba64d37fa2f8015ce3e.png',
  },
  {
    symbol: 'DFD',
    decimals: 18,
    chainId: 56,
    address: '0x9899a98b222fCb2f3dbee7dF45d943093a4ff9ff',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9899a98b222fCb2f3dbee7dF45d943093a4ff9ff.png',
  },
  {
    symbol: 'DFT',
    decimals: 18,
    chainId: 56,
    address: '0x42712dF5009c20fee340B245b510c0395896cF6e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x42712dF5009c20fee340B245b510c0395896cF6e.png',
  },
  {
    symbol: 'DG',
    decimals: 18,
    chainId: 56,
    address: '0x9Fdc3ae5c814b79dcA2556564047C5e7e5449C19',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9Fdc3ae5c814b79dcA2556564047C5e7e5449C19.png',
  },
  {
    symbol: 'DITTO',
    decimals: 9,
    chainId: 56,
    address: '0x233d91A0713155003fc4DcE0AFa871b508B3B715',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x233d91A0713155003fc4DcE0AFa871b508B3B715.png',
  },
  {
    symbol: 'DKT',
    decimals: 18,
    chainId: 56,
    address: '0x7Ceb519718A80Dd78a8545AD8e7f401dE4f2faA7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7Ceb519718A80Dd78a8545AD8e7f401dE4f2faA7.png',
  },
  {
    symbol: 'DLP',
    decimals: 18,
    chainId: 56,
    address: '0x346575fC7f07E6994D76199E41D13dC1575322E1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x346575fC7f07E6994D76199E41D13dC1575322E1.png',
  },
  {
    symbol: 'DMAIL',
    decimals: 18,
    chainId: 56,
    address: '0xcC6f1e1B87cfCbe9221808d2d85C501aab0B5192',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xcC6f1e1B87cfCbe9221808d2d85C501aab0B5192.png',
  },
  {
    symbol: 'DODO',
    decimals: 18,
    chainId: 56,
    address: '0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2.png',
  },
  {
    symbol: 'DOGE',
    decimals: 8,
    chainId: 56,
    address: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xbA2aE424d960c26247Dd6c32edC70B295c744C43.png',
  },
  {
    symbol: 'DOT',
    decimals: 18,
    chainId: 56,
    address: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402.png',
  },
  {
    symbol: 'DPT',
    decimals: 18,
    chainId: 56,
    address: '0xE69cAef10A488D7AF31Da46c89154d025546e990',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xE69cAef10A488D7AF31Da46c89154d025546e990.png',
  },
  {
    symbol: 'DUET',
    decimals: 18,
    chainId: 56,
    address: '0x95EE03e1e2C5c4877f9A298F1C0D6c98698FAB7B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x95EE03e1e2C5c4877f9A298F1C0D6c98698FAB7B.png',
  },
  {
    symbol: 'DUSK',
    decimals: 18,
    chainId: 56,
    address: '0xB2BD0749DBE21f623d9BABa856D3B0f0e1BFEc9C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xB2BD0749DBE21f623d9BABa856D3B0f0e1BFEc9C.png',
  },
  {
    symbol: 'DVI',
    decimals: 18,
    chainId: 56,
    address: '0x758FB037A375F17c7e195CC634D77dA4F554255B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x758FB037A375F17c7e195CC634D77dA4F554255B.png',
  },
  {
    symbol: 'EDU',
    decimals: 18,
    chainId: 56,
    address: '0xBdEAe1cA48894A1759A8374D63925f21f2Ee2639',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xBdEAe1cA48894A1759A8374D63925f21f2Ee2639.png',
  },
  {
    symbol: 'EGLD',
    decimals: 18,
    chainId: 56,
    address: '0xbF7c81FFF98BbE61B40Ed186e4AfD6DDd01337fe',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xbF7c81FFF98BbE61B40Ed186e4AfD6DDd01337fe.png',
  },
  {
    symbol: 'EGO',
    decimals: 18,
    chainId: 56,
    address: '0x44a21B3577924DCD2e9C81A3347D204C36a55466',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x44a21B3577924DCD2e9C81A3347D204C36a55466.png',
  },
  {
    symbol: 'ELON',
    decimals: 18,
    chainId: 56,
    address: '0x7bd6FaBD64813c48545C9c0e312A0099d9be2540',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7bd6FaBD64813c48545C9c0e312A0099d9be2540.png',
  },
  {
    symbol: 'EOS',
    decimals: 18,
    chainId: 56,
    address: '0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6.png',
  },
  {
    symbol: 'EPS',
    decimals: 18,
    chainId: 56,
    address: '0xA7f552078dcC247C2684336020c03648500C6d9F',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xA7f552078dcC247C2684336020c03648500C6d9F.png',
  },
  {
    symbol: 'EQB',
    decimals: 18,
    chainId: 56,
    address: '0x374Ca32fd7934c5d43240E1e73fa9B2283468609',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x374Ca32fd7934c5d43240E1e73fa9B2283468609.png',
  },
  {
    symbol: 'ERA',
    decimals: 18,
    chainId: 56,
    address: '0x6f9F0c4ad9Af7EbD61Ac5A1D4e0F2227F7B0E5f9',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6f9F0c4ad9Af7EbD61Ac5A1D4e0F2227F7B0E5f9.png',
  },
  {
    symbol: 'ERTHA',
    decimals: 18,
    chainId: 56,
    address: '0x62823659d09F9F9D2222058878f89437425eB261',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x62823659d09F9F9D2222058878f89437425eB261.png',
  },
  {
    symbol: 'esRDNT',
    decimals: 18,
    chainId: 56,
    address: '0x016aBB5E48A7B64C2014f8834ecbE56CD72BF13D',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x016aBB5E48A7B64C2014f8834ecbE56CD72BF13D.png',
  },
  {
    symbol: 'ETERNAL',
    decimals: 18,
    chainId: 56,
    address: '0xD44FD09d74cd13838F137B590497595d6b3FEeA4',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xD44FD09d74cd13838F137B590497595d6b3FEeA4.png',
  },
  {
    symbol: 'ETH',
    decimals: 18,
    chainId: 56,
    address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2170Ed0880ac9A755fd29B2688956BD959F933F8.png',
  },
  {
    symbol: 'EURA',
    decimals: 18,
    chainId: 56,
    address: '0x12f31B73D812C6Bb0d735a218c086d44D5fe5f89',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x12f31B73D812C6Bb0d735a218c086d44D5fe5f89.png',
  },
  {
    symbol: 'EZ',
    decimals: 18,
    chainId: 56,
    address: '0x5512014efa6Cd57764Fa743756F7a6Ce3358cC83',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5512014efa6Cd57764Fa743756F7a6Ce3358cC83.png',
  },
  {
    symbol: 'ezETH',
    decimals: 18,
    chainId: 56,
    address: '0x2416092f143378750bb29b79eD961ab195CcEea5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2416092f143378750bb29b79eD961ab195CcEea5.png',
  },
  {
    symbol: 'FDUSD',
    decimals: 18,
    chainId: 56,
    address: '0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409.png',
  },
  {
    symbol: 'FET',
    decimals: 18,
    chainId: 56,
    address: '0x031b41e504677879370e9DBcF937283A8691Fa7f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x031b41e504677879370e9DBcF937283A8691Fa7f.png',
  },
  {
    symbol: 'FIGHT',
    decimals: 18,
    chainId: 56,
    address: '0x4f39c3319188A723003670c3F9B9e7EF991E52F3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4f39c3319188A723003670c3F9B9e7EF991E52F3.png',
  },
  {
    symbol: 'FIL',
    decimals: 18,
    chainId: 56,
    address: '0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153.png',
  },
  {
    symbol: 'FINA',
    decimals: 18,
    chainId: 56,
    address: '0x426c72701833fdDBdFc06c944737C6031645c708',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x426c72701833fdDBdFc06c944737C6031645c708.png',
  },
  {
    symbol: 'FINE',
    decimals: 18,
    chainId: 56,
    address: '0x4e6415a5727ea08aAE4580057187923aeC331227',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4e6415a5727ea08aAE4580057187923aeC331227.png',
  },
  {
    symbol: 'FOR',
    decimals: 18,
    chainId: 56,
    address: '0x658A109C5900BC6d2357c87549B651670E5b0539',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x658A109C5900BC6d2357c87549B651670E5b0539.png',
  },
  {
    symbol: 'FORM',
    decimals: 18,
    chainId: 56,
    address: '0x25A528af62e56512A19ce8c3cAB427807c28CC19',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x25A528af62e56512A19ce8c3cAB427807c28CC19.png',
  },
  {
    symbol: 'FRONT',
    decimals: 18,
    chainId: 56,
    address: '0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b.png',
  },
  {
    symbol: 'FROYO',
    decimals: 18,
    chainId: 56,
    address: '0xe369fec23380f9F14ffD07a1DC4b7c1a9fdD81c9',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe369fec23380f9F14ffD07a1DC4b7c1a9fdD81c9.png',
  },
  {
    symbol: 'FUEL',
    decimals: 18,
    chainId: 56,
    address: '0x2090c8295769791ab7A3CF1CC6e0AA19F35e441A',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2090c8295769791ab7A3CF1CC6e0AA19F35e441A.png',
  },
  {
    symbol: 'FURY',
    decimals: 18,
    chainId: 56,
    address: '0x0203D275D2A65030889aF45ed91D472be3948B92',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0203D275D2A65030889aF45ed91D472be3948B92.png',
  },
  {
    symbol: 'FUSE',
    decimals: 18,
    chainId: 56,
    address: '0x5857c96DaE9cF8511B08Cb07f85753C472D36Ea3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5857c96DaE9cF8511B08Cb07f85753C472D36Ea3.png',
  },
  {
    symbol: 'GAL',
    decimals: 18,
    chainId: 56,
    address: '0xe4Cc45Bb5DBDA06dB6183E8bf016569f40497Aa5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe4Cc45Bb5DBDA06dB6183E8bf016569f40497Aa5.png',
  },
  {
    symbol: 'GEAR',
    decimals: 18,
    chainId: 56,
    address: '0xb4404DaB7C0eC48b428Cf37DeC7fb628bcC41B36',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xb4404DaB7C0eC48b428Cf37DeC7fb628bcC41B36.png',
  },
  {
    symbol: 'GM',
    decimals: 18,
    chainId: 56,
    address: '0xe2604C9561D490624AA35e156e65e590eB749519',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe2604C9561D490624AA35e156e65e590eB749519.png',
  },
  {
    symbol: 'GMEE',
    decimals: 18,
    chainId: 56,
    address: '0x84e9a6F9D240FdD33801f7135908BfA16866939A',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x84e9a6F9D240FdD33801f7135908BfA16866939A.png',
  },
  {
    symbol: 'GMI',
    decimals: 18,
    chainId: 56,
    address: '0x93D8d25E3C9A847a5Da79F79ecaC89461FEcA846',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x93D8d25E3C9A847a5Da79F79ecaC89461FEcA846.png',
  },
  {
    symbol: 'GMT',
    decimals: 8,
    chainId: 56,
    address: '0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1.png',
  },
  {
    symbol: 'GQ',
    decimals: 18,
    chainId: 56,
    address: '0xF700D4c708C2be1463E355F337603183D20E0808',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF700D4c708C2be1463E355F337603183D20E0808.png',
  },
  {
    symbol: 'GRAPE',
    decimals: 18,
    chainId: 56,
    address: '0x555296de6A86E72752e5C5DC091FE49713Aa145C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x555296de6A86E72752e5C5DC091FE49713Aa145C.png',
  },
  {
    symbol: 'GTAI',
    decimals: 18,
    chainId: 56,
    address: '0x003d87d02A2A01E9E8a20f507C83E15DD83A33d1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x003d87d02A2A01E9E8a20f507C83E15DD83A33d1.png',
  },
  {
    symbol: 'GUM',
    decimals: 18,
    chainId: 56,
    address: '0xc53708664b99DF348dd27C3Ac0759d2DA9c40462',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xc53708664b99DF348dd27C3Ac0759d2DA9c40462.png',
  },
  {
    symbol: 'HAI',
    decimals: 8,
    chainId: 56,
    address: '0xaA9E582e5751d703F85912903bacADdFed26484C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xaA9E582e5751d703F85912903bacADdFed26484C.png',
  },
  {
    symbol: 'HAKKA',
    decimals: 18,
    chainId: 56,
    address: '0x1D1eb8E8293222e1a29d2C0E4cE6C0Acfd89AaaC',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1D1eb8E8293222e1a29d2C0E4cE6C0Acfd89AaaC.png',
  },
  {
    symbol: 'HAPPY',
    decimals: 18,
    chainId: 56,
    address: '0xF5d8A096CcCb31b9D7bcE5afE812BE23e3D4690d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF5d8A096CcCb31b9D7bcE5afE812BE23e3D4690d.png',
  },
  {
    symbol: 'HARD',
    decimals: 6,
    chainId: 56,
    address: '0xf79037F6f6bE66832DE4E7516be52826BC3cBcc4',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf79037F6f6bE66832DE4E7516be52826BC3cBcc4.png',
  },
  {
    symbol: 'Helmet',
    decimals: 18,
    chainId: 56,
    address: '0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8.png',
  },
  {
    symbol: 'HERO',
    decimals: 18,
    chainId: 56,
    address: '0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13.png',
  },
  {
    symbol: 'HERO',
    decimals: 18,
    chainId: 56,
    address: '0xE8176d414560cFE1Bf82Fd73B986823B89E4F545',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xE8176d414560cFE1Bf82Fd73B986823B89E4F545.png',
  },
  {
    symbol: 'HFT',
    decimals: 18,
    chainId: 56,
    address: '0x44Ec807ce2F4a6F2737A92e985f318d035883e47',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x44Ec807ce2F4a6F2737A92e985f318d035883e47.png',
  },
  {
    symbol: 'HGET',
    decimals: 6,
    chainId: 56,
    address: '0xC7d8D35EBA58a0935ff2D5a33Df105DD9f071731',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xC7d8D35EBA58a0935ff2D5a33Df105DD9f071731.png',
  },
  {
    symbol: 'HIGH',
    decimals: 18,
    chainId: 56,
    address: '0x5f4Bde007Dc06b867f86EBFE4802e34A1fFEEd63',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5f4Bde007Dc06b867f86EBFE4802e34A1fFEEd63.png',
  },
  {
    symbol: 'HOO',
    decimals: 8,
    chainId: 56,
    address: '0xE1d1F66215998786110Ba0102ef558b22224C016',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xE1d1F66215998786110Ba0102ef558b22224C016.png',
  },
  {
    symbol: 'HOOK',
    decimals: 18,
    chainId: 56,
    address: '0xa260E12d2B924cb899AE80BB58123ac3fEE1E2F0',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa260E12d2B924cb899AE80BB58123ac3fEE1E2F0.png',
  },
  {
    symbol: 'HOOP',
    decimals: 18,
    chainId: 56,
    address: '0xF19cfb40B3774dF6Eed83169Ad5aB0Aaf6865F25',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF19cfb40B3774dF6Eed83169Ad5aB0Aaf6865F25.png',
  },
  {
    symbol: 'HOTCROSS',
    decimals: 18,
    chainId: 56,
    address: '0x4FA7163E153419E0E1064e418dd7A99314Ed27b6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4FA7163E153419E0E1064e418dd7A99314Ed27b6.png',
  },
  {
    symbol: 'HTB',
    decimals: 18,
    chainId: 56,
    address: '0x4e840AADD28DA189B9906674B4Afcb77C128d9ea',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4e840AADD28DA189B9906674B4Afcb77C128d9ea.png',
  },
  {
    symbol: 'HTD',
    decimals: 18,
    chainId: 56,
    address: '0x5E2689412Fae5c29BD575fbe1d5C1CD1e0622A8f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5E2689412Fae5c29BD575fbe1d5C1CD1e0622A8f.png',
  },
  {
    symbol: 'HUAHUA',
    decimals: 6,
    chainId: 56,
    address: '0x9fD470124903957f299a1C90fEdA9043A4619cc6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9fD470124903957f299a1C90fEdA9043A4619cc6.png',
  },
  {
    symbol: 'HZN',
    decimals: 18,
    chainId: 56,
    address: '0xC0eFf7749b125444953ef89682201Fb8c6A917CD',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xC0eFf7749b125444953ef89682201Fb8c6A917CD.png',
  },
  {
    symbol: 'ID',
    decimals: 18,
    chainId: 56,
    address: '0x2dfF88A56767223A5529eA5960Da7A3F5f766406',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2dfF88A56767223A5529eA5960Da7A3F5f766406.png',
  },
  {
    symbol: 'IDIA',
    decimals: 18,
    chainId: 56,
    address: '0x0b15Ddf19D47E6a86A56148fb4aFFFc6929BcB89',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0b15Ddf19D47E6a86A56148fb4aFFFc6929BcB89.png',
  },
  {
    symbol: 'IF',
    decimals: 18,
    chainId: 56,
    address: '0xB0e1fc65C1a741b4662B813eB787d369b8614Af1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xB0e1fc65C1a741b4662B813eB787d369b8614Af1.png',
  },
  {
    symbol: 'INJ',
    decimals: 18,
    chainId: 56,
    address: '0xa2B726B1145A4773F68593CF171187d8EBe4d495',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa2B726B1145A4773F68593CF171187d8EBe4d495.png',
  },
  {
    symbol: 'INSP',
    decimals: 18,
    chainId: 56,
    address: '0x8D279274789CceC8af94a430A5996eAaCE9609A9',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8D279274789CceC8af94a430A5996eAaCE9609A9.png',
  },
  {
    symbol: 'INSUR',
    decimals: 18,
    chainId: 56,
    address: '0x3192CCDdf1CDcE4Ff055EbC80f3F0231b86A7E30',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3192CCDdf1CDcE4Ff055EbC80f3F0231b86A7E30.png',
  },
  {
    symbol: 'IOTX',
    decimals: 18,
    chainId: 56,
    address: '0x9678E42ceBEb63F23197D726B29b1CB20d0064E5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9678E42ceBEb63F23197D726B29b1CB20d0064E5.png',
  },
  {
    symbol: 'IRL',
    decimals: 18,
    chainId: 56,
    address: '0xa80221D067603e30060F75E2458AA361f8eE5402',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa80221D067603e30060F75E2458AA361f8eE5402.png',
  },
  {
    symbol: 'JASMY',
    decimals: 18,
    chainId: 56,
    address: '0x15669CF161946C09a8B207650BfBB00e3d8A2E3E',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x15669CF161946C09a8B207650BfBB00e3d8A2E3E.png',
  },
  {
    symbol: 'JGN',
    decimals: 18,
    chainId: 56,
    address: '0xC13B7a43223BB9Bf4B69BD68Ab20ca1B79d81C75',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xC13B7a43223BB9Bf4B69BD68Ab20ca1B79d81C75.png',
  },
  {
    symbol: 'JUV',
    decimals: 2,
    chainId: 56,
    address: '0xC40C9A843E1c6D01b7578284a9028854f6683b1B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xC40C9A843E1c6D01b7578284a9028854f6683b1B.png',
  },
  {
    symbol: 'KALM',
    decimals: 18,
    chainId: 56,
    address: '0x4BA0057f784858a48fe351445C672FF2a3d43515',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4BA0057f784858a48fe351445C672FF2a3d43515.png',
  },
  {
    symbol: 'KART',
    decimals: 18,
    chainId: 56,
    address: '0x8BDd8DBcBDf0C066cA5f3286d33673aA7A553C10',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8BDd8DBcBDf0C066cA5f3286d33673aA7A553C10.png',
  },
  {
    symbol: 'KAVA',
    decimals: 6,
    chainId: 56,
    address: '0x5F88AB06e8dfe89DF127B2430Bba4Af600866035',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5F88AB06e8dfe89DF127B2430Bba4Af600866035.png',
  },
  {
    symbol: 'kBTC',
    decimals: 18,
    chainId: 56,
    address: '0x9356f6d95b8E109F4b7Ce3E49D672967d3B48383',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9356f6d95b8E109F4b7Ce3E49D672967d3B48383.png',
  },
  {
    symbol: 'KRS',
    decimals: 18,
    chainId: 56,
    address: '0x37b53894e7429f794B56F22a32E1695567Ee9913',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x37b53894e7429f794B56F22a32E1695567Ee9913.png',
  },
  {
    symbol: 'KTN',
    decimals: 18,
    chainId: 56,
    address: '0xDAe6c2A48BFAA66b43815c5548b10800919c993E',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xDAe6c2A48BFAA66b43815c5548b10800919c993E.png',
  },
  {
    symbol: 'KUJI',
    decimals: 6,
    chainId: 56,
    address: '0x073690e6CE25bE816E68F32dCA3e11067c9FB5Cc',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x073690e6CE25bE816E68F32dCA3e11067c9FB5Cc.png',
  },
  {
    symbol: 'KUN',
    decimals: 18,
    chainId: 56,
    address: '0x1A2fb0Af670D0234c2857FaD35b789F8Cb725584',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1A2fb0Af670D0234c2857FaD35b789F8Cb725584.png',
  },
  {
    symbol: 'LAZIO',
    decimals: 8,
    chainId: 56,
    address: '0x77d547256A2cD95F32F67aE0313E450Ac200648d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x77d547256A2cD95F32F67aE0313E450Ac200648d.png',
  },
  {
    symbol: 'LGO',
    decimals: 18,
    chainId: 56,
    address: '0xBe2B6C5E31F292009f495DDBda88e28391C9815E',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xBe2B6C5E31F292009f495DDBda88e28391C9815E.png',
  },
  {
    symbol: 'LIEN',
    decimals: 8,
    chainId: 56,
    address: '0x5d684ADaf3FcFe9CFb5ceDe3abf02F0Cdd1012E3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5d684ADaf3FcFe9CFb5ceDe3abf02F0Cdd1012E3.png',
  },
  {
    symbol: 'LIGHT',
    decimals: 18,
    chainId: 56,
    address: '0x037838b556d9c9d654148a284682C55bB5f56eF4',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x037838b556d9c9d654148a284682C55bB5f56eF4.png',
  },
  {
    symbol: 'LINA',
    decimals: 18,
    chainId: 56,
    address: '0x762539b45A1dCcE3D36d080F74d1AED37844b878',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x762539b45A1dCcE3D36d080F74d1AED37844b878.png',
  },
  {
    symbol: 'LINK',
    decimals: 18,
    chainId: 56,
    address: '0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD.png',
  },
  {
    symbol: 'LISTA',
    decimals: 18,
    chainId: 56,
    address: '0xFceB31A79F71AC9CBDCF853519c1b12D379EdC46',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xFceB31A79F71AC9CBDCF853519c1b12D379EdC46.png',
  },
  {
    symbol: 'lisUSD',
    decimals: 18,
    chainId: 56,
    address: '0x0782b6d8c4551B9760e74c0545a9bCD90bdc41E5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0782b6d8c4551B9760e74c0545a9bCD90bdc41E5.png',
  },
  {
    symbol: 'LIT',
    decimals: 18,
    chainId: 56,
    address: '0xb59490aB09A0f526Cc7305822aC65f2Ab12f9723',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xb59490aB09A0f526Cc7305822aC65f2Ab12f9723.png',
  },
  {
    symbol: 'LMT',
    decimals: 18,
    chainId: 56,
    address: '0x9617857E191354dbEA0b714d78Bc59e57C411087',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9617857E191354dbEA0b714d78Bc59e57C411087.png',
  },
  {
    symbol: 'LOA',
    decimals: 18,
    chainId: 56,
    address: '0x94b69263FCA20119Ae817b6f783Fc0F13B02ad50',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x94b69263FCA20119Ae817b6f783Fc0F13B02ad50.png',
  },
  {
    symbol: 'LOOKS',
    decimals: 18,
    chainId: 56,
    address: '0x590D11c0696b0023176f5D7587d6b2f502a08047',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x590D11c0696b0023176f5D7587d6b2f502a08047.png',
  },
  {
    symbol: 'LTC',
    decimals: 18,
    chainId: 56,
    address: '0x4338665CBB7B2485A8855A139b75D5e34AB0DB94',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4338665CBB7B2485A8855A139b75D5e34AB0DB94.png',
  },
  {
    symbol: 'LTO',
    decimals: 18,
    chainId: 56,
    address: '0x857B222Fc79e1cBBf8Ca5f78CB133d1b7CF34BBd',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x857B222Fc79e1cBBf8Ca5f78CB133d1b7CF34BBd.png',
  },
  {
    symbol: 'lUSD',
    decimals: 18,
    chainId: 56,
    address: '0x23e8a70534308a4AAF76fb8C32ec13d17a3BD89e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x23e8a70534308a4AAF76fb8C32ec13d17a3BD89e.png',
  },
  {
    symbol: 'LVL',
    decimals: 18,
    chainId: 56,
    address: '0xB64E280e9D1B5DbEc4AcceDb2257A87b400DB149',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xB64E280e9D1B5DbEc4AcceDb2257A87b400DB149.png',
  },
  {
    symbol: 'mAMZN',
    decimals: 18,
    chainId: 56,
    address: '0x3947B992DC0147D2D89dF0392213781b04B25075',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3947B992DC0147D2D89dF0392213781b04B25075.png',
  },
  {
    symbol: 'MANA',
    decimals: 18,
    chainId: 56,
    address: '0x26433c8127d9b4e9B71Eaa15111DF99Ea2EeB2f8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x26433c8127d9b4e9B71Eaa15111DF99Ea2EeB2f8.png',
  },
  {
    symbol: 'MANTA',
    decimals: 18,
    chainId: 56,
    address: '0x8581cc815e40615998F4561F3e24e68066293595',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8581cc815e40615998F4561F3e24e68066293595.png',
  },
  {
    symbol: 'MARSH',
    decimals: 18,
    chainId: 56,
    address: '0x2FA5dAF6Fe0708fBD63b1A7D1592577284f52256',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2FA5dAF6Fe0708fBD63b1A7D1592577284f52256.png',
  },
  {
    symbol: 'MASA',
    decimals: 18,
    chainId: 56,
    address: '0x944824290CC12F31ae18Ef51216A223Ba4063092',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x944824290CC12F31ae18Ef51216A223Ba4063092.png',
  },
  {
    symbol: 'MASK',
    decimals: 18,
    chainId: 56,
    address: '0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3.png',
  },
  {
    symbol: 'MATH',
    decimals: 18,
    chainId: 56,
    address: '0xF218184Af829Cf2b0019F8E6F0b2423498a36983',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF218184Af829Cf2b0019F8E6F0b2423498a36983.png',
  },
  {
    symbol: 'MB4',
    decimals: 18,
    chainId: 56,
    address: '0x4536819095a8969c94362ba130EE0bB1cda714Cb',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4536819095a8969c94362ba130EE0bB1cda714Cb.png',
  },
  {
    symbol: 'MBL',
    decimals: 18,
    chainId: 56,
    address: '0x18E37F96628dB3037d633FE4D469Fb1933a63C5B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x18E37F96628dB3037d633FE4D469Fb1933a63C5B.png',
  },
  {
    symbol: 'MBOX',
    decimals: 18,
    chainId: 56,
    address: '0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377.png',
  },
  {
    symbol: 'mBTC',
    decimals: 8,
    chainId: 56,
    address: '0x7c1cCA5b25Fa0bC9AF9275Fb53cBA89DC172b878',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7c1cCA5b25Fa0bC9AF9275Fb53cBA89DC172b878.png',
  },
  {
    symbol: 'MBX',
    decimals: 18,
    chainId: 56,
    address: '0xF95a5532D67C944dfa7EDDD2f8c358Fe0dc7FAc2',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF95a5532D67C944dfa7EDDD2f8c358Fe0dc7FAc2.png',
  },
  {
    symbol: 'MC',
    decimals: 18,
    chainId: 56,
    address: '0xAE493a1F8bbE36BA8E687352F638d4c07C54f8d7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xAE493a1F8bbE36BA8E687352F638d4c07C54f8d7.png',
  },
  {
    symbol: 'mCAKE',
    decimals: 18,
    chainId: 56,
    address: '0x581FA684D0Ec11ccb46B1d92F1F24C8A3F95C0CA',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x581FA684D0Ec11ccb46B1d92F1F24C8A3F95C0CA.png',
  },
  {
    symbol: 'MCB',
    decimals: 18,
    chainId: 56,
    address: '0x5fE80d2CD054645b9419657d3d10d26391780A7B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5fE80d2CD054645b9419657d3d10d26391780A7B.png',
  },
  {
    symbol: 'mCOIN',
    decimals: 18,
    chainId: 56,
    address: '0x49022089e78a8D46Ec87A3AF86a1Db6c189aFA6f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x49022089e78a8D46Ec87A3AF86a1Db6c189aFA6f.png',
  },
  {
    symbol: 'MCRN',
    decimals: 18,
    chainId: 56,
    address: '0xacb2d47827C9813AE26De80965845D80935afd0B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xacb2d47827C9813AE26De80965845D80935afd0B.png',
  },
  {
    symbol: 'mDLP',
    decimals: 18,
    chainId: 56,
    address: '0x11727E5b7Fa33FF4D380F3E7E877F19876c25b97',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x11727E5b7Fa33FF4D380F3E7E877F19876c25b97.png',
  },
  {
    symbol: 'Metis',
    decimals: 18,
    chainId: 56,
    address: '0xe552Fb52a4F19e44ef5A967632DBc320B0820639',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe552Fb52a4F19e44ef5A967632DBc320B0820639.png',
  },
  {
    symbol: 'mGOOGL',
    decimals: 18,
    chainId: 56,
    address: '0x62D71B23bF15218C7d2D7E48DBbD9e9c650B173f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x62D71B23bF15218C7d2D7E48DBbD9e9c650B173f.png',
  },
  {
    symbol: 'MGP',
    decimals: 18,
    chainId: 56,
    address: '0xD06716E1Ff2E492Cc5034c2E81805562dd3b45fa',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xD06716E1Ff2E492Cc5034c2E81805562dd3b45fa.png',
  },
  {
    symbol: 'MHUNT',
    decimals: 18,
    chainId: 56,
    address: '0x2C717059b366714d267039aF8F59125CAdce6D8c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2C717059b366714d267039aF8F59125CAdce6D8c.png',
  },
  {
    symbol: 'MIR',
    decimals: 18,
    chainId: 56,
    address: '0x5B6DcF557E2aBE2323c48445E8CC948910d8c2c9',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5B6DcF557E2aBE2323c48445E8CC948910d8c2c9.png',
  },
  {
    symbol: 'MIX',
    decimals: 18,
    chainId: 56,
    address: '0xB67754f5b4C704A24d2db68e661b2875a4dDD197',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xB67754f5b4C704A24d2db68e661b2875a4dDD197.png',
  },
  {
    symbol: 'MIX',
    decimals: 18,
    chainId: 56,
    address: '0xCF1B55D79E824da0Ae0652F96C66fe33263d743f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xCF1B55D79E824da0Ae0652F96C66fe33263d743f.png',
  },
  {
    symbol: 'MIXOLD',
    decimals: 18,
    chainId: 56,
    address: '0x398f7827DcCbeFe6990478876bBF3612D93baF05',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x398f7827DcCbeFe6990478876bBF3612D93baF05.png',
  },
  {
    symbol: 'mNFLX',
    decimals: 18,
    chainId: 56,
    address: '0xa04F060077D90Fe2647B61e4dA4aD1F97d6649dc',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa04F060077D90Fe2647B61e4dA4aD1F97d6649dc.png',
  },
  {
    symbol: 'MONI',
    decimals: 18,
    chainId: 56,
    address: '0x9573c88aE3e37508f87649f87c4dd5373C9F31e0',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9573c88aE3e37508f87649f87c4dd5373C9F31e0.png',
  },
  {
    symbol: 'mPENDLE',
    decimals: 18,
    chainId: 56,
    address: '0x0465aad9da170798433F4aB7fa7Ec8b9b9bf0Bb1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0465aad9da170798433F4aB7fa7Ec8b9b9bf0Bb1.png',
  },
  {
    symbol: 'MTRG',
    decimals: 18,
    chainId: 56,
    address: '0xBd2949F67DcdC549c6Ebe98696449Fa79D988A9F',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xBd2949F67DcdC549c6Ebe98696449Fa79D988A9F.png',
  },
  {
    symbol: 'mTSLA',
    decimals: 18,
    chainId: 56,
    address: '0xF215A127A196e3988C09d052e16BcFD365Cd7AA3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF215A127A196e3988C09d052e16BcFD365Cd7AA3.png',
  },
  {
    symbol: 'MUBI',
    decimals: 18,
    chainId: 56,
    address: '0x38e382F74dfb84608F3C1F10187f6bEf5951DE93',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x38e382F74dfb84608F3C1F10187f6bEf5951DE93.png',
  },
  {
    symbol: 'mwBETH',
    decimals: 18,
    chainId: 56,
    address: '0x7dC91cBD6CB5A3E6A95EED713Aa6bF1d987146c8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7dC91cBD6CB5A3E6A95EED713Aa6bF1d987146c8.png',
  },
  {
    symbol: 'MX',
    decimals: 18,
    chainId: 56,
    address: '0x9F882567A62a5560d147d64871776EeA72Df41D3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9F882567A62a5560d147d64871776EeA72Df41D3.png',
  },
  {
    symbol: 'NABOX',
    decimals: 18,
    chainId: 56,
    address: '0x755f34709E369D37C6Fa52808aE84A32007d1155',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x755f34709E369D37C6Fa52808aE84A32007d1155.png',
  },
  {
    symbol: 'NAOS',
    decimals: 18,
    chainId: 56,
    address: '0x758d08864fB6cCE3062667225ca10b8F00496cc2',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x758d08864fB6cCE3062667225ca10b8F00496cc2.png',
  },
  {
    symbol: 'NBT',
    decimals: 18,
    chainId: 56,
    address: '0x1D3437E570e93581Bd94b2fd8Fbf202d4a65654A',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1D3437E570e93581Bd94b2fd8Fbf202d4a65654A.png',
  },
  {
    symbol: 'NFP',
    decimals: 18,
    chainId: 56,
    address: '0x75E8ddB518bB757b4282cd5b83bb70d4101D12FB',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x75E8ddB518bB757b4282cd5b83bb70d4101D12FB.png',
  },
  {
    symbol: 'NFT',
    decimals: 6,
    chainId: 56,
    address: '0x20eE7B720f4E4c4FFcB00C4065cdae55271aECCa',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x20eE7B720f4E4c4FFcB00C4065cdae55271aECCa.png',
  },
  {
    symbol: 'NMT',
    decimals: 18,
    chainId: 56,
    address: '0x03AA6298F1370642642415EDC0db8b957783e8D6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x03AA6298F1370642642415EDC0db8b957783e8D6.png',
  },
  {
    symbol: 'NRV',
    decimals: 18,
    chainId: 56,
    address: '0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096.png',
  },
  {
    symbol: 'NULS',
    decimals: 8,
    chainId: 56,
    address: '0x8CD6e29d3686d24d3C2018CEe54621eA0f89313B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8CD6e29d3686d24d3C2018CEe54621eA0f89313B.png',
  },
  {
    symbol: 'NVT',
    decimals: 8,
    chainId: 56,
    address: '0xf0E406c49C63AbF358030A299C0E00118C4C6BA5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf0E406c49C63AbF358030A299C0E00118C4C6BA5.png',
  },
  {
    symbol: 'O3',
    decimals: 18,
    chainId: 56,
    address: '0xEe9801669C6138E84bD50dEB500827b776777d28',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xEe9801669C6138E84bD50dEB500827b776777d28.png',
  },
  {
    symbol: 'ODDZ',
    decimals: 18,
    chainId: 56,
    address: '0xCD40F2670CF58720b694968698A5514e924F742d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xCD40F2670CF58720b694968698A5514e924F742d.png',
  },
  {
    symbol: 'OG',
    decimals: 2,
    chainId: 56,
    address: '0xf05E45aD22150677a017Fbd94b84fBB63dc9b44c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf05E45aD22150677a017Fbd94b84fBB63dc9b44c.png',
  },
  {
    symbol: 'OIN',
    decimals: 8,
    chainId: 56,
    address: '0x658E64FFcF40D240A43D52CA9342140316Ae44fA',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x658E64FFcF40D240A43D52CA9342140316Ae44fA.png',
  },
  {
    symbol: 'OLE',
    decimals: 18,
    chainId: 56,
    address: '0xa865197A84E780957422237B5D152772654341F3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa865197A84E780957422237B5D152772654341F3.png',
  },
  {
    symbol: 'ONE',
    decimals: 18,
    chainId: 56,
    address: '0x03fF0ff224f904be3118461335064bB48Df47938',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x03fF0ff224f904be3118461335064bB48Df47938.png',
  },
  {
    symbol: 'ONE',
    decimals: 18,
    chainId: 56,
    address: '0x04BAf95Fd4C52fd09a56D840bAEe0AB8D7357bf0',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x04BAf95Fd4C52fd09a56D840bAEe0AB8D7357bf0.png',
  },
  {
    symbol: 'ONT',
    decimals: 18,
    chainId: 56,
    address: '0xFd7B3A77848f1C2D67E05E54d78d174a0C850335',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xFd7B3A77848f1C2D67E05E54d78d174a0C850335.png',
  },
  {
    symbol: 'OORT',
    decimals: 18,
    chainId: 56,
    address: '0x5651fA7a726B9Ec0cAd00Ee140179912B6E73599',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5651fA7a726B9Ec0cAd00Ee140179912B6E73599.png',
  },
  {
    symbol: 'ORBS',
    decimals: 18,
    chainId: 56,
    address: '0x43a8cab15D06d3a5fE5854D714C37E7E9246F170',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x43a8cab15D06d3a5fE5854D714C37E7E9246F170.png',
  },
  {
    symbol: 'ordi',
    decimals: 18,
    chainId: 56,
    address: '0xe2aE1a99bBd2eFab0a5C38f2146B7aCE61aBC5cE',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe2aE1a99bBd2eFab0a5C38f2146B7aCE61aBC5cE.png',
  },
  {
    symbol: 'OSAK',
    decimals: 18,
    chainId: 56,
    address: '0x11cd72f7A4B699c67f225ca8aBb20bC9F8DB90c7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x11cd72f7A4B699c67f225ca8aBb20bC9F8DB90c7.png',
  },
  {
    symbol: 'OVN',
    decimals: 18,
    chainId: 56,
    address: '0x259B30C916e440FB79747cD559207FfdaBBae057',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x259B30C916e440FB79747cD559207FfdaBBae057.png',
  },
  {
    symbol: 'pBTC',
    decimals: 18,
    chainId: 56,
    address: '0xeD28A457A5A76596ac48d87C0f577020F6Ea1c4C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xeD28A457A5A76596ac48d87C0f577020F6Ea1c4C.png',
  },
  {
    symbol: 'pCWS',
    decimals: 18,
    chainId: 56,
    address: '0xbcf39F0EDDa668C58371E519AF37CA705f2bFcbd',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xbcf39F0EDDa668C58371E519AF37CA705f2bFcbd.png',
  },
  {
    symbol: 'PEAK',
    decimals: 8,
    chainId: 56,
    address: '0x630d98424eFe0Ea27fB1b3Ab7741907DFFEaAd78',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x630d98424eFe0Ea27fB1b3Ab7741907DFFEaAd78.png',
  },
  {
    symbol: 'PEEL',
    decimals: 18,
    chainId: 56,
    address: '0x734548a9e43d2D564600b1B2ed5bE9C2b911c6aB',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x734548a9e43d2D564600b1B2ed5bE9C2b911c6aB.png',
  },
  {
    symbol: 'PENDLE',
    decimals: 18,
    chainId: 56,
    address: '0xb3Ed0A426155B79B898849803E3B36552f7ED507',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xb3Ed0A426155B79B898849803E3B36552f7ED507.png',
  },
  {
    symbol: 'PEOPLE',
    decimals: 18,
    chainId: 56,
    address: '0x2c44b726ADF1963cA47Af88B284C06f30380fC78',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2c44b726ADF1963cA47Af88B284C06f30380fC78.png',
  },
  {
    symbol: 'PEPE',
    decimals: 18,
    chainId: 56,
    address: '0x25d887Ce7a35172C62FeBFD67a1856F20FaEbB00',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x25d887Ce7a35172C62FeBFD67a1856F20FaEbB00.png',
  },
  {
    symbol: 'PERL',
    decimals: 18,
    chainId: 56,
    address: '0x0F9E4D49f25de22c2202aF916B681FBB3790497B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0F9E4D49f25de22c2202aF916B681FBB3790497B.png',
  },
  {
    symbol: 'PEX',
    decimals: 18,
    chainId: 56,
    address: '0x6a0b66710567b6beb81A71F7e9466450a91a384b',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6a0b66710567b6beb81A71F7e9466450a91a384b.png',
  },
  {
    symbol: 'PHA',
    decimals: 18,
    chainId: 56,
    address: '0x0112e557d400474717056C4e6D40eDD846F38351',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0112e557d400474717056C4e6D40eDD846F38351.png',
  },
  {
    symbol: 'PLANET',
    decimals: 18,
    chainId: 56,
    address: '0xCa6d678e74f553f0E59cccC03ae644a3c2c5EE7d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xCa6d678e74f553f0E59cccC03ae644a3c2c5EE7d.png',
  },
  {
    symbol: 'PLAY',
    decimals: 18,
    chainId: 56,
    address: '0xD069599E718f963bD84502b49ba8F8657fAF5B3a',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xD069599E718f963bD84502b49ba8F8657fAF5B3a.png',
  },
  {
    symbol: 'PMON',
    decimals: 18,
    chainId: 56,
    address: '0x1796ae0b0fa4862485106a0de9b654eFE301D0b2',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1796ae0b0fa4862485106a0de9b654eFE301D0b2.png',
  },
  {
    symbol: 'PNP',
    decimals: 18,
    chainId: 56,
    address: '0x5012c90F14d190607662CA8344120812Aaa2639D',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5012c90F14d190607662CA8344120812Aaa2639D.png',
  },
  {
    symbol: 'PNT',
    decimals: 18,
    chainId: 56,
    address: '0xdaacB0Ab6Fb34d24E8a67BfA14BF4D95D4C7aF92',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xdaacB0Ab6Fb34d24E8a67BfA14BF4D95D4C7aF92.png',
  },
  {
    symbol: 'POOLX',
    decimals: 18,
    chainId: 56,
    address: '0xbAeA9aBA1454DF334943951d51116aE342eAB255',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xbAeA9aBA1454DF334943951d51116aE342eAB255.png',
  },
  {
    symbol: 'pOPEN',
    decimals: 18,
    chainId: 56,
    address: '0xaBaE871B7E3b67aEeC6B46AE9FE1A91660AadAC5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xaBaE871B7E3b67aEeC6B46AE9FE1A91660AadAC5.png',
  },
  {
    symbol: 'PORTO',
    decimals: 8,
    chainId: 56,
    address: '0x49f2145d6366099e13B10FbF80646C0F377eE7f6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x49f2145d6366099e13B10FbF80646C0F377eE7f6.png',
  },
  {
    symbol: 'POTS',
    decimals: 18,
    chainId: 56,
    address: '0x3Fcca8648651E5b974DD6d3e50F61567779772A8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3Fcca8648651E5b974DD6d3e50F61567779772A8.png',
  },
  {
    symbol: 'PRIMAL',
    decimals: 18,
    chainId: 56,
    address: '0xCb5327Ed4649548e0d73E70b633cdfd99aF6Da87',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xCb5327Ed4649548e0d73E70b633cdfd99aF6Da87.png',
  },
  {
    symbol: 'PRL',
    decimals: 18,
    chainId: 56,
    address: '0xd07e82440A395f3F3551b42dA9210CD1Ef4f8B24',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xd07e82440A395f3F3551b42dA9210CD1Ef4f8B24.png',
  },
  {
    symbol: 'PROM',
    decimals: 18,
    chainId: 56,
    address: '0xaF53d56ff99f1322515E54FdDE93FF8b3b7DAFd5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xaF53d56ff99f1322515E54FdDE93FF8b3b7DAFd5.png',
  },
  {
    symbol: 'PROS',
    decimals: 18,
    chainId: 56,
    address: '0xEd8c8Aa8299C10f067496BB66f8cC7Fb338A3405',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xEd8c8Aa8299C10f067496BB66f8cC7Fb338A3405.png',
  },
  {
    symbol: 'PSG',
    decimals: 2,
    chainId: 56,
    address: '0xBc5609612b7C44BEf426De600B5fd1379DB2EcF1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xBc5609612b7C44BEf426De600B5fd1379DB2EcF1.png',
  },
  {
    symbol: 'PSTAKE',
    decimals: 18,
    chainId: 56,
    address: '0x4C882ec256823eE773B25b414d36F92ef58a7c0C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4C882ec256823eE773B25b414d36F92ef58a7c0C.png',
  },
  {
    symbol: 'pxETH',
    decimals: 18,
    chainId: 56,
    address: '0x300d2c875C6fb8Ce4bf5480B4d34b7c9ea8a33A4',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x300d2c875C6fb8Ce4bf5480B4d34b7c9ea8a33A4.png',
  },
  {
    symbol: 'QBT',
    decimals: 18,
    chainId: 56,
    address: '0x17B7163cf1Dbd286E262ddc68b553D899B93f526',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x17B7163cf1Dbd286E262ddc68b553D899B93f526.png',
  },
  {
    symbol: 'QI',
    decimals: 18,
    chainId: 56,
    address: '0x8729438EB15e2C8B576fCc6AeCdA6A148776C0F5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8729438EB15e2C8B576fCc6AeCdA6A148776C0F5.png',
  },
  {
    symbol: 'QKC',
    decimals: 18,
    chainId: 56,
    address: '0xA1434F1FC3F437fa33F7a781E041961C0205B5Da',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xA1434F1FC3F437fa33F7a781E041961C0205B5Da.png',
  },
  {
    symbol: 'QSD',
    decimals: 18,
    chainId: 56,
    address: '0x07AaA29E63FFEB2EBf59B33eE61437E1a91A3bb2',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x07AaA29E63FFEB2EBf59B33eE61437E1a91A3bb2.png',
  },
  {
    symbol: 'QUIDD',
    decimals: 18,
    chainId: 56,
    address: '0x7961Ade0a767c0E5B67Dd1a1F78ba44F727642Ed',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7961Ade0a767c0E5B67Dd1a1F78ba44F727642Ed.png',
  },
  {
    symbol: 'RABBIT',
    decimals: 18,
    chainId: 56,
    address: '0x95a1199EBA84ac5f19546519e287d43D2F0E1b41',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x95a1199EBA84ac5f19546519e287d43D2F0E1b41.png',
  },
  {
    symbol: 'RACA',
    decimals: 18,
    chainId: 56,
    address: '0x12BB890508c125661E03b09EC06E404bc9289040',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x12BB890508c125661E03b09EC06E404bc9289040.png',
  },
  {
    symbol: 'RAMP',
    decimals: 18,
    chainId: 56,
    address: '0x8519EA49c997f50cefFa444d240fB655e89248Aa',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8519EA49c997f50cefFa444d240fB655e89248Aa.png',
  },
  {
    symbol: 'rBNB',
    decimals: 18,
    chainId: 56,
    address: '0xF027E525D491ef6ffCC478555FBb3CFabB3406a6',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF027E525D491ef6ffCC478555FBb3CFabB3406a6.png',
  },
  {
    symbol: 'RDNT',
    decimals: 18,
    chainId: 56,
    address: '0xf7DE7E8A6bd59ED41a4b5fe50278b3B7f31384dF',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf7DE7E8A6bd59ED41a4b5fe50278b3B7f31384dF.png',
  },
  {
    symbol: 'RDP',
    decimals: 18,
    chainId: 56,
    address: '0x27c073e8427aa493a90b8dC8b73A89e670FD77bB',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x27c073e8427aa493a90b8dC8b73A89e670FD77bB.png',
  },
  {
    symbol: 'REEF',
    decimals: 18,
    chainId: 56,
    address: '0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e.png',
  },
  {
    symbol: 'renBTC',
    decimals: 8,
    chainId: 56,
    address: '0xfCe146bF3146100cfe5dB4129cf6C82b0eF4Ad8c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xfCe146bF3146100cfe5dB4129cf6C82b0eF4Ad8c.png',
  },
  {
    symbol: 'REVV',
    decimals: 18,
    chainId: 56,
    address: '0x833F307aC507D47309fD8CDD1F835BeF8D702a93',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x833F307aC507D47309fD8CDD1F835BeF8D702a93.png',
  },
  {
    symbol: 'RFOX',
    decimals: 18,
    chainId: 56,
    address: '0x0a3A21356793B49154Fd3BbE91CBc2A16c0457f5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0a3A21356793B49154Fd3BbE91CBc2A16c0457f5.png',
  },
  {
    symbol: 'RPG',
    decimals: 18,
    chainId: 56,
    address: '0x61dc650C10Ec3c758d251Cd2D1Ab45AF1A43e941',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x61dc650C10Ec3c758d251Cd2D1Ab45AF1A43e941.png',
  },
  {
    symbol: 'RPGOLD',
    decimals: 18,
    chainId: 56,
    address: '0xc2098a8938119A52B1F7661893c0153A6CB116d5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xc2098a8938119A52B1F7661893c0153A6CB116d5.png',
  },
  {
    symbol: 'rUSD',
    decimals: 18,
    chainId: 56,
    address: '0x07663837218A003e66310a01596af4bf4e44623D',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x07663837218A003e66310a01596af4bf4e44623D.png',
  },
  {
    symbol: 'SABLE',
    decimals: 18,
    chainId: 56,
    address: '0x1eE098cBaF1f846d5Df1993f7e2d10AFb35A878d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1eE098cBaF1f846d5Df1993f7e2d10AFb35A878d.png',
  },
  {
    symbol: 'SAND',
    decimals: 18,
    chainId: 56,
    address: '0x67b725d7e342d7B611fa85e859Df9697D9378B2e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x67b725d7e342d7B611fa85e859Df9697D9378B2e.png',
  },
  {
    symbol: 'SANTOS',
    decimals: 8,
    chainId: 56,
    address: '0xA64455a4553C9034236734FadDAddbb64aCE4Cc7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xA64455a4553C9034236734FadDAddbb64aCE4Cc7.png',
  },
  {
    symbol: 'sats',
    decimals: 18,
    chainId: 56,
    address: '0x143D7A700a533B4baF6D693449b278A8A2F5927d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x143D7A700a533B4baF6D693449b278A8A2F5927d.png',
  },
  {
    symbol: 'SD',
    decimals: 18,
    chainId: 56,
    address: '0x3BC5AC0dFdC871B365d159f728dd1B9A0B5481E8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3BC5AC0dFdC871B365d159f728dd1B9A0B5481E8.png',
  },
  {
    symbol: 'SDAO',
    decimals: 18,
    chainId: 56,
    address: '0x90Ed8F1dc86388f14b64ba8fb4bbd23099f18240',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x90Ed8F1dc86388f14b64ba8fb4bbd23099f18240.png',
  },
  {
    symbol: 'sdCAKE',
    decimals: 18,
    chainId: 56,
    address: '0x6a1c1447F97B27dA23dC52802F5f1435b5aC821A',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6a1c1447F97B27dA23dC52802F5f1435b5aC821A.png',
  },
  {
    symbol: 'SDT',
    decimals: 18,
    chainId: 56,
    address: '0x07715EE7219B07b8e01CC7d2787f4e5e75860383',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x07715EE7219B07b8e01CC7d2787f4e5e75860383.png',
  },
  {
    symbol: 'SFP',
    decimals: 18,
    chainId: 56,
    address: '0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb.png',
  },
  {
    symbol: 'SFUND',
    decimals: 18,
    chainId: 56,
    address: '0x477bC8d23c634C154061869478bce96BE6045D12',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x477bC8d23c634C154061869478bce96BE6045D12.png',
  },
  {
    symbol: 'SHEESHA',
    decimals: 18,
    chainId: 56,
    address: '0x232FB065D9d24c34708eeDbF03724f2e95ABE768',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x232FB065D9d24c34708eeDbF03724f2e95ABE768.png',
  },
  {
    symbol: 'SHELL',
    decimals: 18,
    chainId: 56,
    address: '0x208cfEc94d2BA8B8537da7A9BB361c6baAD77272',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x208cfEc94d2BA8B8537da7A9BB361c6baAD77272.png',
  },
  {
    symbol: 'SIS',
    decimals: 18,
    chainId: 56,
    address: '0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835.png',
  },
  {
    symbol: 'SKILL',
    decimals: 18,
    chainId: 56,
    address: '0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab.png',
  },
  {
    symbol: 'slisBNB',
    decimals: 18,
    chainId: 56,
    address: '0xB0b84D294e0C75A6abe60171b70edEb2EFd14A1B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xB0b84D294e0C75A6abe60171b70edEb2EFd14A1B.png',
  },
  {
    symbol: 'SOL',
    decimals: 18,
    chainId: 56,
    address: '0x570A5D26f7765Ecb712C0924E4De545B89fD43dF',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x570A5D26f7765Ecb712C0924E4De545B89fD43dF.png',
  },
  {
    symbol: 'SolvBTC',
    decimals: 18,
    chainId: 56,
    address: '0x4aae823a6a0b376De6A78e74eCC5b079d38cBCf7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4aae823a6a0b376De6A78e74eCC5b079d38cBCf7.png',
  },
  {
    symbol: 'SolvBTC.BBN',
    decimals: 18,
    chainId: 56,
    address: '0x1346b618dC92810EC74163e4c27004c921D446a5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1346b618dC92810EC74163e4c27004c921D446a5.png',
  },
  {
    symbol: 'SolvBTC.ENA',
    decimals: 18,
    chainId: 56,
    address: '0x53E63a31fD1077f949204b94F431bCaB98F72BCE',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x53E63a31fD1077f949204b94F431bCaB98F72BCE.png',
  },
  {
    symbol: 'SPARTA',
    decimals: 18,
    chainId: 56,
    address: '0x3910db0600eA925F63C36DdB1351aB6E2c6eb102',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x3910db0600eA925F63C36DdB1351aB6E2c6eb102.png',
  },
  {
    symbol: 'SPIN',
    decimals: 18,
    chainId: 56,
    address: '0x6AA217312960A21aDbde1478DC8cBCf828110A67',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6AA217312960A21aDbde1478DC8cBCf828110A67.png',
  },
  {
    symbol: 'SPS',
    decimals: 18,
    chainId: 56,
    address: '0x1633b7157e7638C4d6593436111Bf125Ee74703F',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1633b7157e7638C4d6593436111Bf125Ee74703F.png',
  },
  {
    symbol: 'SQUAD',
    decimals: 18,
    chainId: 56,
    address: '0x724A32dFFF9769A0a0e1F0515c0012d1fB14c3bd',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x724A32dFFF9769A0a0e1F0515c0012d1fB14c3bd.png',
  },
  {
    symbol: 'stBTC',
    decimals: 18,
    chainId: 56,
    address: '0xf6718b2701D4a6498eF77D7c152b2137Ab28b8A3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf6718b2701D4a6498eF77D7c152b2137Ab28b8A3.png',
  },
  {
    symbol: 'STG',
    decimals: 18,
    chainId: 56,
    address: '0xB0D502E938ed5f4df2E681fE6E419ff29631d62b',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xB0D502E938ed5f4df2E681fE6E419ff29631d62b.png',
  },
  {
    symbol: 'stkBNB',
    decimals: 18,
    chainId: 56,
    address: '0xc2E9d07F66A89c44062459A47a0D2Dc038E4fb16',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xc2E9d07F66A89c44062459A47a0D2Dc038E4fb16.png',
  },
  {
    symbol: 'STONE',
    decimals: 18,
    chainId: 56,
    address: '0x80137510979822322193FC997d400D5A6C747bf7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x80137510979822322193FC997d400D5A6C747bf7.png',
  },
  {
    symbol: 'SUSHI',
    decimals: 18,
    chainId: 56,
    address: '0x947950BcC74888a40Ffa2593C5798F11Fc9124C4',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x947950BcC74888a40Ffa2593C5798F11Fc9124C4.png',
  },
  {
    symbol: 'SUTER',
    decimals: 18,
    chainId: 56,
    address: '0x4CfbBdfBd5BF0814472fF35C72717Bd095ADa055',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4CfbBdfBd5BF0814472fF35C72717Bd095ADa055.png',
  },
  {
    symbol: 'SWAMP',
    decimals: 18,
    chainId: 56,
    address: '0xc5A49b4CBe004b6FD55B30Ba1dE6AC360FF9765d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xc5A49b4CBe004b6FD55B30Ba1dE6AC360FF9765d.png',
  },
  {
    symbol: 'SWG',
    decimals: 18,
    chainId: 56,
    address: '0xe792f64C582698b8572AAF765bDC426AC3aEfb6B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe792f64C582698b8572AAF765bDC426AC3aEfb6B.png',
  },
  {
    symbol: 'SWINGBY',
    decimals: 18,
    chainId: 56,
    address: '0x71DE20e0C4616E7fcBfDD3f875d568492cBE4739',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x71DE20e0C4616E7fcBfDD3f875d568492cBE4739.png',
  },
  {
    symbol: 'SWTH',
    decimals: 8,
    chainId: 56,
    address: '0xC0ECB8499D8dA2771aBCbF4091DB7f65158f1468',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xC0ECB8499D8dA2771aBCbF4091DB7f65158f1468.png',
  },
  {
    symbol: 'SXP',
    decimals: 18,
    chainId: 56,
    address: '0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A.png',
  },
  {
    symbol: 'tBTC',
    decimals: 9,
    chainId: 56,
    address: '0x2cD1075682b0FCCaADd0Ca629e138E64015Ba11c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2cD1075682b0FCCaADd0Ca629e138E64015Ba11c.png',
  },
  {
    symbol: 'tDOGE',
    decimals: 8,
    chainId: 56,
    address: '0xe550a593d09FBC8DCD557b5C88Cea6946A8b404A',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe550a593d09FBC8DCD557b5C88Cea6946A8b404A.png',
  },
  {
    symbol: 'TEM',
    decimals: 9,
    chainId: 56,
    address: '0x19e6BfC1A6e4B042Fb20531244D47E252445df01',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x19e6BfC1A6e4B042Fb20531244D47E252445df01.png',
  },
  {
    symbol: 'TEN',
    decimals: 18,
    chainId: 56,
    address: '0xdFF8cb622790b7F92686c722b02CaB55592f152C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xdFF8cb622790b7F92686c722b02CaB55592f152C.png',
  },
  {
    symbol: 'THG',
    decimals: 18,
    chainId: 56,
    address: '0x9fD87aEfe02441B123c3c32466cD9dB4c578618f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9fD87aEfe02441B123c3c32466cD9dB4c578618f.png',
  },
  {
    symbol: 'TINC',
    decimals: 18,
    chainId: 56,
    address: '0x05aD6E30A855BE07AfA57e08a4f30d00810a402e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x05aD6E30A855BE07AfA57e08a4f30d00810a402e.png',
  },
  {
    symbol: 'TITAN',
    decimals: 18,
    chainId: 56,
    address: '0xe898EDc43920F357A93083F1d4460437dE6dAeC2',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xe898EDc43920F357A93083F1d4460437dE6dAeC2.png',
  },
  {
    symbol: 'TKO',
    decimals: 18,
    chainId: 56,
    address: '0x9f589e3eabe42ebC94A44727b3f3531C0c877809',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x9f589e3eabe42ebC94A44727b3f3531C0c877809.png',
  },
  {
    symbol: 'TLM',
    decimals: 4,
    chainId: 56,
    address: '0x2222227E22102Fe3322098e4CBfE18cFebD57c95',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x2222227E22102Fe3322098e4CBfE18cFebD57c95.png',
  },
  {
    symbol: 'TLOS',
    decimals: 18,
    chainId: 56,
    address: '0xb6C53431608E626AC81a9776ac3e999c5556717c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xb6C53431608E626AC81a9776ac3e999c5556717c.png',
  },
  {
    symbol: 'TPT',
    decimals: 4,
    chainId: 56,
    address: '0xECa41281c24451168a37211F0bc2b8645AF45092',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xECa41281c24451168a37211F0bc2b8645AF45092.png',
  },
  {
    symbol: 'TRADE',
    decimals: 18,
    chainId: 56,
    address: '0x7af173F350D916358AF3e218Bdf2178494Beb748',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7af173F350D916358AF3e218Bdf2178494Beb748.png',
  },
  {
    symbol: 'TRIVIA',
    decimals: 3,
    chainId: 56,
    address: '0xb465f3cb6Aba6eE375E12918387DE1eaC2301B05',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xb465f3cb6Aba6eE375E12918387DE1eaC2301B05.png',
  },
  {
    symbol: 'TRUMP',
    decimals: 9,
    chainId: 56,
    address: '0x4eA98c1999575aaadfb38237Dd015c5E773F75a2',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4eA98c1999575aaadfb38237Dd015c5E773F75a2.png',
  },
  {
    symbol: 'TRX',
    decimals: 18,
    chainId: 56,
    address: '0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B.png',
  },
  {
    symbol: 'TRX',
    decimals: 6,
    chainId: 56,
    address: '0xCE7de646e7208a4Ef112cb6ed5038FA6cC6b12e3',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xCE7de646e7208a4Ef112cb6ed5038FA6cC6b12e3.png',
  },
  {
    symbol: 'TT',
    decimals: 18,
    chainId: 56,
    address: '0x990E7154bB999FAa9b2fa5Ed29E822703311eA85',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x990E7154bB999FAa9b2fa5Ed29E822703311eA85.png',
  },
  {
    symbol: 'TUSD',
    decimals: 18,
    chainId: 56,
    address: '0x40af3827F39D0EAcBF4A168f8D4ee67c121D11c9',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x40af3827F39D0EAcBF4A168f8D4ee67c121D11c9.png',
  },
  {
    symbol: 'TUSDOLD',
    decimals: 18,
    chainId: 56,
    address: '0x14016E85a25aeb13065688cAFB43044C2ef86784',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x14016E85a25aeb13065688cAFB43044C2ef86784.png',
  },
  {
    symbol: 'TWT',
    decimals: 18,
    chainId: 56,
    address: '0x4B0F1812e5Df2A09796481Ff14017e6005508003',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4B0F1812e5Df2A09796481Ff14017e6005508003.png',
  },
  {
    symbol: 'TXL',
    decimals: 18,
    chainId: 56,
    address: '0x1FFD0b47127fdd4097E54521C9E2c7f0D66AafC5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1FFD0b47127fdd4097E54521C9E2c7f0D66AafC5.png',
  },
  {
    symbol: 'UBXT',
    decimals: 18,
    chainId: 56,
    address: '0xBbEB90cFb6FAFa1F69AA130B7341089AbeEF5811',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xBbEB90cFb6FAFa1F69AA130B7341089AbeEF5811.png',
  },
  {
    symbol: 'UNFI',
    decimals: 18,
    chainId: 56,
    address: '0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B.png',
  },
  {
    symbol: 'UNI',
    decimals: 18,
    chainId: 56,
    address: '0xBf5140A22578168FD562DCcF235E5D43A02ce9B1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xBf5140A22578168FD562DCcF235E5D43A02ce9B1.png',
  },
  {
    symbol: 'uniBTC',
    decimals: 8,
    chainId: 56,
    address: '0x6B2a01A5f79dEb4c2f3c0eDa7b01DF456FbD726a',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6B2a01A5f79dEb4c2f3c0eDa7b01DF456FbD726a.png',
  },
  {
    symbol: 'unshETH',
    decimals: 18,
    chainId: 56,
    address: '0x0Ae38f7E10A43B5b2fB064B42a2f4514cbA909ef',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0Ae38f7E10A43B5b2fB064B42a2f4514cbA909ef.png',
  },
  {
    symbol: 'UNW',
    decimals: 18,
    chainId: 56,
    address: '0x5b65cd9feb54F1Df3D0C60576003344079f8Dc06',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5b65cd9feb54F1Df3D0C60576003344079f8Dc06.png',
  },
  {
    symbol: 'USDC',
    decimals: 18,
    chainId: 56,
    address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d.png',
  },
  {
    symbol: 'USDT',
    decimals: 18,
    chainId: 56,
    address: '0x55d398326f99059fF775485246999027B3197955',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x55d398326f99059fF775485246999027B3197955.png',
  },
  {
    symbol: 'USDV',
    decimals: 6,
    chainId: 56,
    address: '0x323665443CEf804A3b5206103304BD4872EA4253',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x323665443CEf804A3b5206103304BD4872EA4253.png',
  },
  {
    symbol: 'USH',
    decimals: 18,
    chainId: 56,
    address: '0x91d6d6aF7635B7b23A8CED9508117965180e2362',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x91d6d6aF7635B7b23A8CED9508117965180e2362.png',
  },
  {
    symbol: 'UST',
    decimals: 18,
    chainId: 56,
    address: '0x23396cF899Ca06c4472205fC903bDB4de249D6fC',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x23396cF899Ca06c4472205fC903bDB4de249D6fC.png',
  },
  {
    symbol: 'VAI',
    decimals: 18,
    chainId: 56,
    address: '0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7.png',
  },
  {
    symbol: 'VET',
    decimals: 18,
    chainId: 56,
    address: '0x6FDcdfef7c496407cCb0cEC90f9C5Aaa1Cc8D888',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6FDcdfef7c496407cCb0cEC90f9C5Aaa1Cc8D888.png',
  },
  {
    symbol: 'VIA',
    decimals: 18,
    chainId: 56,
    address: '0x21ac3bB914f90A2Bb1a16088E673a9fdDa641434',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x21ac3bB914f90A2Bb1a16088E673a9fdDa641434.png',
  },
  {
    symbol: 'VRT',
    decimals: 18,
    chainId: 56,
    address: '0x5F84ce30DC3cF7909101C69086c50De191895883',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5F84ce30DC3cF7909101C69086c50De191895883.png',
  },
  {
    symbol: 'WATCH',
    decimals: 18,
    chainId: 56,
    address: '0x7A9f28EB62C791422Aa23CeAE1dA9C847cBeC9b0',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7A9f28EB62C791422Aa23CeAE1dA9C847cBeC9b0.png',
  },
  {
    symbol: 'WAULTx',
    decimals: 18,
    chainId: 56,
    address: '0xB64E638E60D154B43f660a6BF8fD8a3b249a6a21',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xB64E638E60D154B43f660a6BF8fD8a3b249a6a21.png',
  },
  {
    symbol: 'wBETH',
    decimals: 18,
    chainId: 56,
    address: '0xa2E3356610840701BDf5611a53974510Ae27E2e1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa2E3356610840701BDf5611a53974510Ae27E2e1.png',
  },
  {
    symbol: 'WBNB',
    decimals: 18,
    chainId: 56,
    address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c.png',
  },
  {
    symbol: 'WBTC',
    decimals: 8,
    chainId: 56,
    address: '0x0555E30da8f98308EdB960aa94C0Db47230d2B9c',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0555E30da8f98308EdB960aa94C0Db47230d2B9c.png',
  },
  {
    symbol: 'weETH',
    decimals: 18,
    chainId: 56,
    address: '0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A.png',
  },
  {
    symbol: 'WELL',
    decimals: 18,
    chainId: 56,
    address: '0xf07a32Eb035b786898c00bB1C64d8c6F8E7a46D5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xf07a32Eb035b786898c00bB1C64d8c6F8E7a46D5.png',
  },
  {
    symbol: 'WEX',
    decimals: 18,
    chainId: 56,
    address: '0xa9c41A46a6B3531d28d5c32F6633dd2fF05dFB90',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa9c41A46a6B3531d28d5c32F6633dd2fF05dFB90.png',
  },
  {
    symbol: 'WIN',
    decimals: 18,
    chainId: 56,
    address: '0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99.png',
  },
  {
    symbol: 'WMASS',
    decimals: 8,
    chainId: 56,
    address: '0x7e396BfC8a2f84748701167c2d622F041A1D7a17',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7e396BfC8a2f84748701167c2d622F041A1D7a17.png',
  },
  {
    symbol: 'WMX',
    decimals: 18,
    chainId: 56,
    address: '0xa75d9ca2a0a1D547409D82e1B06618EC284A2CeD',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa75d9ca2a0a1D547409D82e1B06618EC284A2CeD.png',
  },
  {
    symbol: 'WNCG',
    decimals: 18,
    chainId: 56,
    address: '0x52242cbAb41e290E9E17CCC50Cc437bB60020a9d',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x52242cbAb41e290E9E17CCC50Cc437bB60020a9d.png',
  },
  {
    symbol: 'WOM',
    decimals: 18,
    chainId: 56,
    address: '0xAD6742A35fB341A9Cc6ad674738Dd8da98b94Fb1',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xAD6742A35fB341A9Cc6ad674738Dd8da98b94Fb1.png',
  },
  {
    symbol: 'WOO',
    decimals: 18,
    chainId: 56,
    address: '0x4691937a7508860F876c9c0a2a617E7d9E945D4B',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4691937a7508860F876c9c0a2a617E7d9E945D4B.png',
  },
  {
    symbol: 'WOOP',
    decimals: 18,
    chainId: 56,
    address: '0x8b303d5BbfBbf46F1a4d9741E491e06986894e18',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x8b303d5BbfBbf46F1a4d9741E491e06986894e18.png',
  },
  {
    symbol: 'wROSE',
    decimals: 18,
    chainId: 56,
    address: '0xF00600eBC7633462BC4F9C61eA2cE99F5AAEBd4a',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xF00600eBC7633462BC4F9C61eA2cE99F5AAEBd4a.png',
  },
  {
    symbol: 'WSG',
    decimals: 18,
    chainId: 56,
    address: '0xA58950F05FeA2277d2608748412bf9F802eA4901',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xA58950F05FeA2277d2608748412bf9F802eA4901.png',
  },
  {
    symbol: 'WSI',
    decimals: 18,
    chainId: 56,
    address: '0x837A130aED114300Bab4f9f1F4f500682f7efd48',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x837A130aED114300Bab4f9f1F4f500682f7efd48.png',
  },
  {
    symbol: 'wstETH',
    decimals: 18,
    chainId: 56,
    address: '0x26c5e01524d2E6280A48F2c50fF6De7e52E9611C',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x26c5e01524d2E6280A48F2c50fF6De7e52E9611C.png',
  },
  {
    symbol: 'wxUSDT',
    decimals: 6,
    chainId: 56,
    address: '0x524bC91Dc82d6b90EF29F76A3ECAaBAffFD490Bc',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x524bC91Dc82d6b90EF29F76A3ECAaBAffFD490Bc.png',
  },
  {
    symbol: 'WZRD',
    decimals: 18,
    chainId: 56,
    address: '0xFa40d8FC324bcdD6Bbae0e086De886c571C225d4',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xFa40d8FC324bcdD6Bbae0e086De886c571C225d4.png',
  },
  {
    symbol: 'xALGO',
    decimals: 6,
    chainId: 56,
    address: '0x0034719300501B06E10Ebb1D07ea5967301F0941',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x0034719300501B06E10Ebb1D07ea5967301F0941.png',
  },
  {
    symbol: 'XCAD',
    decimals: 18,
    chainId: 56,
    address: '0xa026Ad2ceDa16Ca5FC28fd3C72f99e2C332c8a26',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xa026Ad2ceDa16Ca5FC28fd3C72f99e2C332c8a26.png',
  },
  {
    symbol: 'XCN',
    decimals: 18,
    chainId: 56,
    address: '0x7324c7C0d95CEBC73eEa7E85CbAac0dBdf88a05b',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7324c7C0d95CEBC73eEa7E85CbAac0dBdf88a05b.png',
  },
  {
    symbol: 'XCV',
    decimals: 18,
    chainId: 56,
    address: '0x4be63a9b26EE89b9a3a13fd0aA1D0b2427C135f8',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4be63a9b26EE89b9a3a13fd0aA1D0b2427C135f8.png',
  },
  {
    symbol: 'XED',
    decimals: 18,
    chainId: 56,
    address: '0x5621b5A3f4a8008c4CCDd1b942B121c8B1944F1f',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5621b5A3f4a8008c4CCDd1b942B121c8B1944F1f.png',
  },
  {
    symbol: 'XEND',
    decimals: 18,
    chainId: 56,
    address: '0x4a080377f83D669D7bB83B3184a8A5E61B500608',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x4a080377f83D669D7bB83B3184a8A5E61B500608.png',
  },
  {
    symbol: 'xMARK',
    decimals: 9,
    chainId: 56,
    address: '0x26A5dFab467d4f58fB266648CAe769503CEC9580',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x26A5dFab467d4f58fB266648CAe769503CEC9580.png',
  },
  {
    symbol: 'XMS',
    decimals: 18,
    chainId: 56,
    address: '0x7859B01BbF675d67Da8cD128a50D155cd881B576',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7859B01BbF675d67Da8cD128a50D155cd881B576.png',
  },
  {
    symbol: 'XRGB',
    decimals: 18,
    chainId: 56,
    address: '0x5cc5E64AB764A0f1E97F23984E20fD4528356a6a',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x5cc5E64AB764A0f1E97F23984E20fD4528356a6a.png',
  },
  {
    symbol: 'XRP',
    decimals: 18,
    chainId: 56,
    address: '0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE.png',
  },
  {
    symbol: 'XTZ',
    decimals: 18,
    chainId: 56,
    address: '0x16939ef78684453bfDFb47825F8a5F714f12623a',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x16939ef78684453bfDFb47825F8a5F714f12623a.png',
  },
  {
    symbol: 'XVS',
    decimals: 18,
    chainId: 56,
    address: '0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63.png',
  },
  {
    symbol: 'XWG',
    decimals: 18,
    chainId: 56,
    address: '0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc.png',
  },
  {
    symbol: 'YEL',
    decimals: 18,
    chainId: 56,
    address: '0xD3b71117E6C1558c1553305b44988cd944e97300',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xD3b71117E6C1558c1553305b44988cd944e97300.png',
  },
  {
    symbol: 'YFI',
    decimals: 18,
    chainId: 56,
    address: '0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e.png',
  },
  {
    symbol: 'YFII',
    decimals: 18,
    chainId: 56,
    address: '0x7F70642d88cf1C4a3a7abb072B53B929b653edA5',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x7F70642d88cf1C4a3a7abb072B53B929b653edA5.png',
  },
  {
    symbol: 'ZBC',
    decimals: 9,
    chainId: 56,
    address: '0x37a56cdcD83Dce2868f721De58cB3830C44C6303',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x37a56cdcD83Dce2868f721De58cB3830C44C6303.png',
  },
  {
    symbol: 'ZEC',
    decimals: 18,
    chainId: 56,
    address: '0x1Ba42e5193dfA8B03D15dd1B86a3113bbBEF8Eeb',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1Ba42e5193dfA8B03D15dd1B86a3113bbBEF8Eeb.png',
  },
  {
    symbol: 'ZEE',
    decimals: 18,
    chainId: 56,
    address: '0x44754455564474A89358B2C2265883DF993b12F0',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x44754455564474A89358B2C2265883DF993b12F0.png',
  },
  {
    symbol: 'ZIL',
    decimals: 12,
    chainId: 56,
    address: '0xb86AbCb37C3A4B64f74f59301AFF131a1BEcC787',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0xb86AbCb37C3A4B64f74f59301AFF131a1BEcC787.png',
  },
  {
    symbol: 'ZOO',
    decimals: 18,
    chainId: 56,
    address: '0x1D229B958D5DDFca92146585a8711aECbE56F095',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x1D229B958D5DDFca92146585a8711aECbE56F095.png',
  },
  {
    symbol: 'ZRO',
    decimals: 18,
    chainId: 56,
    address: '0x6985884C4392D348587B19cb9eAAf157F13271cd',
    iconSrc: 'https://tokens.pancakeswap.finance/images/0x6985884C4392D348587B19cb9eAAf157F13271cd.png',
  },
];

    